import { BACKEND_API_HOST } from '@/app/config';
import { CameraFacingInterval } from './facingIntervalBuffer';

interface SendOptions {
  keepalive?: boolean;
}

export default async function sendCameraFacingIntervals(
  meetingHash: string,
  intervals: CameraFacingInterval[],
  { keepalive = false }: SendOptions = {},
): Promise<boolean> {
  try {
    const response = await fetch(
      `${BACKEND_API_HOST}/api/schedule/video-meeting/${meetingHash}/camera-facing-intervals/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // The interval boundaries are on the customer phone's clock, which can
        // be minutes out. Stamping the send lets the backend measure that gap
        // and take it back off before placing the intervals on the recording.
        body: JSON.stringify({ intervals, client_sent_at: new Date().toISOString() }),
        keepalive,
      },
    );
    return response.ok;
  } catch {
    return false;
  }
}
